import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type FilePdfProps = {
    className?: string;
};

const FilePdf: FunctionComponent<FilePdfProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'file-pdf'}
            viewBox="0 0 250 250"
        >
            <path d="M148.2 0H30v250h189V73.7L148.2 0zm-.2 12.8L203 70h-55V12.8zM210 241H39V9h100v70h71v162z" />
            <path d="M123.4 124s4.3-24.2 3.1-32.4c-.2-1.1-.3-1.4-.6-2.3l-.4-.9c-1.2-2.7-3.4-5.5-7-5.3l-2.1-.1h-.1c-4 0-7.2 2-8.1 5.1-2.6 9.5.1 23.8 4.9 42.2l-1.2 3c-3.5 8.4-7.8 16.9-11.6 24.4l-.5 1c-4 7.9-7.7 14.5-11 20.2l-3.4 1.8c-.2.1-6.1 3.2-7.5 4.1-11.6 7-19.4 14.8-20.6 21.1-.4 2-.1 4.6 2 5.7l3.3 1.7c1.4.7 2.9 1.1 4.5 1.1 8.3 0 17.9-10.3 31.2-33.5 15.3-5 32.7-9.1 48-11.4 11.6 6.6 26 11.1 35 11.1 1.6 0 3-.2 4.1-.5 1.7-.5 3.2-1.4 4.1-2.8 1.8-2.6 2.1-6.3 1.6-10-.1-1.1-1-2.5-2-3.4-2.7-2.6-8.6-4-17.7-4.2-6.1-.1-13.5.5-21.3 1.6-3.5-2-7.1-4.2-9.9-6.8-7.6-7.1-13.9-16.9-17.8-27.6.6-1.2.8-2 1-2.9zm-57.9 83.9c1.5-4.1 7.5-12.3 16.3-19.6.6-.5 1.9-1.7 3.2-2.9-9.2 14.8-15.4 20.7-19.5 22.5zm106.2-40.8c4.9 0 6.3 0 11.1 1.2s4.8 3.7 4 4.2c-.8.5-3.2.8-4.7.8-4.9 0-10.9-2.2-19.3-5.8 3.3-.3 6.2-.4 8.9-.4zm-53.8-79.9c2.7 0 4.2 6.7 4.3 13 .1 6.3-1.3 10.7-3.2 14-1.5-4.8-2.2-12.5-2.2-17.5 0 0-.1-9.5 1.1-9.5zm17 74.1c.8.7 1.7 1.4 2.6 2.1-13.4 2.7-25 5.9-35.2 9.8 1.9-3.3 3.8-6.8 5.8-10.5 4.8-9.1 7.9-16.2 10.1-22.1 4.5 8.2 10.1 15.2 16.7 20.7z" />
        </svg>
    );
};
export default FilePdf;
